module.exports = __webpack_public_path__ + "uarm-images/data-graph-chart-report.svg";